export default __webpack_public_path__ + "static/media/Coverage.167f8752.svg";